import { render, staticRenderFns } from "./WorkPositionPage.vue?vue&type=template&id=355e51e1&scoped=true&"
import script from "./WorkPositionPage.vue?vue&type=script&lang=js&"
export * from "./WorkPositionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355e51e1",
  null
  
)

export default component.exports